import Alpine from "alpinejs";
import MenuDropdown from "./MenuDropdown.js";
import mask from "@alpinejs/mask";
import intersect from "@alpinejs/intersect";

Alpine.plugin(intersect);
Alpine.plugin(mask);
window.Alpine = Alpine;
Alpine.store("modalStore", {
    isOpen: false,
    open() {
        this.isOpen = true;
    },
    close() {
        this.isOpen = false;
    },
});
Alpine.store("youtubeModal", {
    isOpen: false,
    link: null,
    toggle() {
        this.isOpen = !this.isOpen;
    },
    close() {
        Alpine.store("modalStore").close();
        this.link = null;
        this.isOpen = false;
    },
    open(link) {
        console.log("open");
        Alpine.store("modalStore").open();
        this.link = link;
        this.isOpen = true;
    },
});
Alpine.store("callbackModal", {
    isOpen: false,
    link: null,
    toggle() {
        this.isOpen = !this.isOpen;
    },
    close() {
        Alpine.store("modalStore").close();
        this.link = null;
        this.isOpen = false;
    },
    open(link) {
        Alpine.store("modalStore").open();
        this.link = link;
        this.isOpen = true;
    },
});

Alpine.data("MenuDropdown", MenuDropdown);
Alpine.start();
Livewire.on("openModal", () => {
    Alpine.store("modalStore").open();
});
Livewire.on("closeModal", () => {
    Alpine.store("modalStore").close();
});

Livewire.on("closeModalForm", () => {
    Alpine.store("callbackModal").close();
});
Livewire.on("popstateListener", () => {
    window.addEventListener("popstate", () => {
        if (!window.location.search) {
            Alpine.store("modalStore").close();
        }
    });
});
